import { Fragment } from 'react';

import BlogArticle2Up from '@/components/BlogComponents/BlogArticle2Up/BlogArticle2Up';
import BlogCuratedArticleSplit from '@/components/BlogComponents/BlogCuratedArticleSplit/BlogCuratedArticleSplit';
import type {
  CuratedArticleGridType,
  CuratedArticleSplitType,
} from '@/contentful/api/api.types';

const BlogCuratedContentSection = ({
  curatedBlogContent,
}: {
  curatedBlogContent: (CuratedArticleGridType | CuratedArticleSplitType)[];
}) => {
  if (!curatedBlogContent) return null;

  return (
    <Fragment>
      {curatedBlogContent?.map((item, index) => {
        switch (item?.contentTypeName) {
          case 'CuratedArticleSplit':
            return (
              <BlogCuratedArticleSplit
                content={item as CuratedArticleSplitType}
                // biome-ignore lint/suspicious/noArrayIndexKey: Automated migration to Biome
                key={index}
              />
            );
          case 'CuratedArticleGrid':
            return (
              <BlogArticle2Up
                content={item as CuratedArticleGridType}
                // biome-ignore lint/suspicious/noArrayIndexKey: Automated migration to Biome
                key={index}
              />
            );
          default:
            return null;
        }
      })}
    </Fragment>
  );
};

export default BlogCuratedContentSection;
